// extracted by mini-css-extract-plugin
export default {"cookie__wrapper":"CookieInfo_cookie__wrapper__49WG3","text__wrapper":"CookieInfo_text__wrapper__jqrEC","accept__btn":"CookieInfo_accept__btn__DRsAB"};